import { css } from 'styled-components';
import { responsiveProperty } from './responsiveProperty.js';

var marginPropsNames = ['m', 'mt', 'mr', 'mb', 'ml'];
var marginProps = css(["", ";", ";", ";", ";", ";"], function (props) {
  return responsiveProperty('margin', props.m);
}, function (props) {
  return props.mt && responsiveProperty('marginTop', props.mt);
}, function (props) {
  return props.mr && responsiveProperty('marginRight', props.mr);
}, function (props) {
  return props.mb && responsiveProperty('marginBottom', props.mb);
}, function (props) {
  return props.ml && responsiveProperty('marginLeft', props.ml);
});

export { marginProps, marginPropsNames };
